import React, { useEffect, useState, createContext } from "react";
import Box from "@mui/material/Box";
import Contestant from "./Contestant";
import axios from "axios";
import Typography from "@mui/material/Typography";
import Loader from "../utilities/loader";
import { useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
const getuser = process.env.REACT_APP_API_GET_USER;
// const getuser = "http://127.0.0.1:9090/api/user/get-user";

export const UserContext = createContext(null);

export default function Index() {
  const { id } = useParams();
  let validID = !!parseInt(id) || id.length === 3;
  const [load, setLoad] = useState(validID);
  const [success, setSuccess] = useState(null);
  const [notFound, setNotFound] = useState(false);

  const [user, setUser] = useState({
    user: {
      votes: {
        stage1: "",
        stage2: "",
        stage3: "",
      },
      name: "",
      id: "",
      gender: "",
      description: "",
      picture: "",
      log: [],
    },
    position: "",
    competeScore: "",
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (validID) {
      axios
        .get(`${getuser}/${id}`)
        .then((response) => {
          if (
            response.status === 200 ||
            (response.status === 201 && response.data)
          ) {
            setSuccess(true);
            setUser(response.data);
            // console.log(response.data)
          }
        })
        .catch((err) => {
          setSuccess(false);
          setNotFound(true);
          console.log(err);
        })
        .finally(() => {
          setLoad(false);
        });
    }
  }, []);

  const Container = styled(Box)(({ theme }) => ({
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: 15,
    textAlign: "center",
  }));

  return (
    <>
      {load && <Loader />}
      {success && (
        <UserContext.Provider value={user}>
          <Contestant />
        </UserContext.Provider>
      )}
      {notFound && (
        <Container>
          <Typography variant="h6" fontWeight="bold">
            Contestant not found
          </Typography>
          <Typography>
            This contestant might not have made it to the final of the Kiddies
            Crown Contest.
          </Typography>
        </Container>
      )}
      {!validID && (
        <Container>
          <Typography variant="h6" fontWeight="bold">
            Invalid ID: {id}
          </Typography>
          <Typography>
            Kindly confirm the contestant's ID and try again.
          </Typography>
        </Container>
      )}
    </>
  );
}
